import React from 'react';
import { View, Text, Image } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Divider } from '@shared/components/md-design-system/Layout';
import { TDevice } from '../types/deviceTypes';
import DeviceLabelValueRow from './DeviceLabelValueRow';

interface DeviceRowProps {
  device: TDevice;
  isLast: boolean;
}

const DeviceRow: React.FC<DeviceRowProps> = ({ device, isLast }) => {
  const { t } = useTranslation();

  const measurementLabel = (device.measurementTypes ?? [])
    .map(type => t(`screens.profile.myDevices.measurementTypeLabels.${type}`, { defaultValue: type }))
    .join(', ');

  return (
    <>
      <View className="flex-row py-5 gap-4">
        <View className="w-24 h-24 rounded-lg bg-gray-100 items-center justify-center overflow-hidden flex-shrink-0">
          {device.imageUrl ? (
            <Image
              source={{ uri: device.imageUrl }}
              style={{ width: '70%', height: '70%' }}
              resizeMode="contain"
            />
          ) : (
            <Text className="text-3xl">📟</Text>
          )}
        </View>

        <View className="flex-1">
          <Text className="text-base font-bold text-gray-900">{device.name}</Text>
          {device.manufacturer && (
            <Text className="text-base text-gray-500 mt-0.5">{device.manufacturer}</Text>
          )}

          <View className="mt-2 gap-0.5">
            {measurementLabel.length > 0 && (
              <DeviceLabelValueRow
                label={t('screens.profile.myDevices.measurementTypes')}
                value={measurementLabel}
              />
            )}
            {device.udi && (
              <DeviceLabelValueRow
                label={t('screens.profile.myDevices.udi')}
                value={device.udi}
              />
            )}
            {device.deviceClass && (
              <DeviceLabelValueRow
                label={t('screens.profile.myDevices.classification')}
                value={device.deviceClass}
              />
            )}
          </View>
        </View>
      </View>

      {!isLast && <Divider spacing="none" variant="light" />}
    </>
  );
};

export default DeviceRow;
